import { Button, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { AppLoader, Tags } from "@/components/utils"
import { useAPIResources } from "@/hooks"
import { setQueryCache, tagsAPI } from "@/utils"
import type { TQuestionProps } from "./types"
import { getChoicesByBinaryMask } from "./utils"

export function QuestionTags({ question, value, setValue, size = "md" }: TQuestionProps) {
  const { t } = useTranslation("tags")
  const category = question.meta.category ?? "tags"
  const { data: { data: tags } = {}, isLoading } = useAPIResources(tagsAPI, {
    where: { category },
    ...setQueryCache(3600e3),
    refetchOnMount: false,
  })

  const safeValue = value ?? 0
  const choices = getChoicesByBinaryMask(safeValue)

  if (isLoading) return <AppLoader />
  if (!tags) return <Text c="red">Error loading tags</Text>

  return (
    <Tags>
      {tags?.map((tag, idx) => {
        const isSelected = choices.includes(idx)
        return (
          <Button
            key={tag.id}
            color="gray"
            size={`compact-${size}`}
            variant={isSelected ? "filled" : "outline"}
            onClick={() => setValue(isSelected ? safeValue - 2 ** idx : safeValue + 2 ** idx)}
          >
            {t(tag.id)}
          </Button>
        )
      })}
    </Tags>
  )
}
